import { Col, Row, Spin } from 'antd';

interface PriceDetailsProps {
    priceRates: Record<string, any> | null;
    loadingRate: boolean;
}

const PriceDetails: React.FC<PriceDetailsProps> = ({ priceRates, loadingRate }) => {
    const renderRateDetails = (details: any, key: string) => {
        if (details.Posted && details.Posted !== 'None') {
            return (
                <Row key={key}>
                    <Col className="gutter-row_left" span={16}>
                        <p className='rate_text'>{(key.replace(/_/g, ' ')).toUpperCase()}</p>
                    </Col>
                    <Col className="gutter-row_right" span={8}>
                        <div>{details.Posted}</div>
                    </Col>
                </Row>
            );
        }
        return null;
    };

    const renderSubscriptions = (subscriptions: any, key: string) => {
        return Object.keys(subscriptions).map(subKey => {
            const subDetail = subscriptions[subKey];
            if (subDetail.Posted && subDetail.Posted !== 'None') {
                return (
                    <Row key={`SUBSCRIPTIONS_${subKey}`}>
                        <Col className="gutter-row_left" span={16}>
                            <p className='rate_text'>{(key.replace(/_/g, ' ')).toUpperCase()}</p>
                        </Col>
                        <Col className="gutter-row_right" span={8}>
                            <div>{subDetail.Posted}</div>
                        </Col>
                    </Row>
                );
            }
            return null;
        });
    };


    return (
        <div>
            <p className='price_detail_title'>Price Details</p>
            <Spin spinning={loadingRate}>
                <div className='price_detail_content'>
                    {priceRates && Object.entries(priceRates).map(([key, value]) => {
                        if (key === 'SUBSCRIPTIONS') {
                            return (
                                <div key={key}>
                                    {renderSubscriptions(value, key)}
                                </div>
                            );
                        } else {
                            return renderRateDetails(value, key);
                        }
                    })}
                </div>
            </Spin>
        </div>
    );
}

export default PriceDetails;
